import axios from 'axios';
import { API_URL } from './config';

axios.interceptors.request.use(
  config => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;

    return config;
  },
  error => {
    Promise.reject(error);
  },
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    let originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry && localStorage.getItem('token')) {
      originalRequest._retry = true;

      return axios
        .post(`${API_URL}/login/new`, {
          token: localStorage.getItem('token'),
        })
        .then(response => {
          localStorage.setItem('token', response.data);

          return axios(originalRequest);
        });
    } else if (error.response && error.response.status === 401 && originalRequest._retry) {
      localStorage.removeItem('token');
      window.location.href = '/';

      return;
    }

    return Promise.reject(error);
  },
);

export default axios;
